"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePaymentDetailsPopup = exports.showPopup = exports.selectPopupManager = exports.selectPopupDetails = exports.selectPaymentDetailsPopup = exports.selectOfferData = exports.selectEditDeliveryDetailsPopup = exports.resetPaymentDetailsPopupState = exports.popupSlice = exports.hidePopup = exports.default = exports.POPUP_TYPES = exports.PAYMENT_DETAILS_STEPS = void 0;
var _toolkit = require("@reduxjs/toolkit");
const POPUP_TYPES = exports.POPUP_TYPES = {
  UPDATE_SUBSCRIPTION_POPUP: 'updateSubscription',
  SWITCH_PLAN_POPUP: 'switchPlan',
  PAUSE_SUBSCRIPTION_POPUP: 'pauseSubscription',
  RESUME_SUBSCRIPTION_POPUP: 'resumeSubscription',
  CANCEL_SWITCH_POPUP: 'cancelSwitch',
  CANCEL_PAUSE_POPUP: 'cancelPause',
  EDIT_DELIVERY_DETAILS_POPUP: 'editDeliveryDetails'
};
const PAYMENT_DETAILS_STEPS = exports.PAYMENT_DETAILS_STEPS = {
  PAYMENT_DETAILS_UPDATE: 'PAYMENT_DETAILS_UPDATE',
  DELETE_PAYMENT_DETAILS: 'DELETE_PAYMENT_DETAILS',
  FINALIZE_ADYEN: 'FINALIZE_ADYEN',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};
const initialState = {
  isOpen: false,
  isLoading: false,
  currentType: null,
  updateSubscription: null,
  switchPlan: null,
  pauseSubscription: null,
  cancelSwitch: null,
  cancelPause: null,
  resumeSubscription: null,
  editDeliveryDetails: {
    giftId: null,
    offerId: '',
    offerTitle: ''
  },
  paymentDetails: {
    isOpen: false,
    isLoading: false,
    step: PAYMENT_DETAILS_STEPS.PAYMENT_DETAILS_UPDATE,
    initPaymentMethod: null
  }
};
const popupSlice = exports.popupSlice = (0, _toolkit.createSlice)({
  name: 'popupManager',
  initialState,
  reducers: {
    updatePaymentDetailsPopup(state, action) {
      state.paymentDetails = {
        ...state.paymentDetails,
        ...action.payload
      };
    },
    resetPaymentDetailsPopupState(state) {
      state.paymentDetails = initialState.paymentDetails;
    },
    showPopup(state, action) {
      if (state.currentType) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        state[state.currentType] = initialState[state.currentType];
        state.currentType = null;
      }
      state.isOpen = true;
      state.currentType = action.payload.type;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      state[action.payload.type] = action.payload.data;
    },
    hidePopup: () => initialState
  }
});
const selectPaymentDetailsPopup = state => state.popupManager.paymentDetails;
exports.selectPaymentDetailsPopup = selectPaymentDetailsPopup;
const selectEditDeliveryDetailsPopup = state => state.popupManager.editDeliveryDetails;
exports.selectEditDeliveryDetailsPopup = selectEditDeliveryDetailsPopup;
const selectPopupDetails = state => ({
  isOpen: state.popupManager.isOpen,
  isLoading: state.popupManager.isLoading,
  currentType: state.popupManager.currentType
});
exports.selectPopupDetails = selectPopupDetails;
const selectOfferData = state => {
  var _state$popupManager$u;
  return (_state$popupManager$u = state.popupManager.updateSubscription) === null || _state$popupManager$u === void 0 ? void 0 : _state$popupManager$u.offerData;
};
exports.selectOfferData = selectOfferData;
const selectPopupManager = state => state.popupManager;
exports.selectPopupManager = selectPopupManager;
const {
  updatePaymentDetailsPopup,
  resetPaymentDetailsPopupState,
  showPopup,
  hidePopup
} = popupSlice.actions;
exports.hidePopup = hidePopup;
exports.showPopup = showPopup;
exports.resetPaymentDetailsPopupState = resetPaymentDetailsPopupState;
exports.updatePaymentDetailsPopup = updatePaymentDetailsPopup;
var _default = exports.default = popupSlice.reducer;